import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-signs1-in-month-display',
  templateUrl: './signs1-in-month-display.component.html',
  styleUrls: ['./signs1-in-month-display.component.css']
})
export class Signs1InMonthDisplayComponent implements OnInit {
  @Input() preDayIcon!: string;
  @Input() postDayIcon!: string;
  @Input() currentIndexId!: number;
  @Input() preSignName!: string;
  @Input() postSignName!: string;
  @Input() currentMontName!: string;
  @Input() postColor!: string;
  @Input() preColor!: string;


  @Input() preElement!: string;
  @Input() preQuality!: string;
  @Input() preGlyph!: string;
  @Input() preHouse!: string;
  @Input() prePlanet!: string;

  @Input() preElementName!: string;
  @Input() preQualityName!: string;
  @Input() preHouseName!: string;
  @Input() prePlanetName!: string;
  @Input() preShortDescription!: string;

  @Input() postElementName!: string;
  @Input() postQualityName!: string;
  @Input() postHouseName!: string;
  @Input() postPlanetName!: string;
  @Input() postShortDescription!: string;

  @Input() postElement!: string;
  @Input() postQuality!: string;
  @Input() postGlyph!: string;
  @Input() postHouse!: string;
  @Input() postPlanet!: string;

  @Input() showStartSign: boolean = true;  //default setting

  @Output() seeDifferentMonth: EventEmitter<any> = new EventEmitter();
  @Output() seeDifferentView:  EventEmitter<any> = new EventEmitter();
  @Output() gotoSignProfile:  EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges){
    // this.setData();
  };

  toggleMonthSigns () {
    if(this.showStartSign) {
    this.showStartSign = !this.showStartSign;
    } else {
    this.showStartSign = true;

    }
  };
  prevMonth(){
    this.seeDifferentMonth.emit('prev');
  };
  nextMonth(){
    this.seeDifferentMonth.emit('next');
  };
  changeViewMode(){
    this.seeDifferentView.emit('show2');
  }
  signProfile(signName: string){
    this.gotoSignProfile.emit(signName);
  }


}
